//--------------------------------
//スマホボタンとメニューの処理
//--------------------------------

//100vhの高さ(px)をカスタムプロパティ(--vh)に設定
export function spMenuMove() {
	var height = window.innerHeight;
	document.documentElement.style.setProperty('--vh', height / 100 + 'px');


	// スマホメニュー表示(
	const jsBtn = document.querySelector('#js-btn');
	const jsBox = document.querySelector('#js-box');
	const jsBody = document.querySelector('body');
	const jsHtml = document.querySelector('html');

	const spLink = document.querySelectorAll('.l-menuSp a');
	const subMenu = document.querySelectorAll('.c-subMenu__list a');

	jsBtn.addEventListener('click', () => {
		jsBtn.classList.toggle('is-buttonClose');
		jsBox.classList.toggle('is-open');
		//後ろのコンテンツ固定と背景を暗くする
		jsBody.classList.toggle('is-fixed');
		jsHtml.classList.toggle('is-fixed');
	})


	// 選択されたメニュー以外のメニューclassの取り外し
	spLink.forEach(function (spLinks) {
		spLinks.addEventListener('click', function () {
			jsBtn.classList.remove('is-buttonClose');
			jsBox.classList.remove('is-open');
		});
	})

	//ページ内リンクがクリックされた時にスマホメニューを閉じる(version1)
	// subMenu.forEach(function(subMenus){
	// 	subMenus.addEventListener('click',function(){
	// 		jsBox.classList.remove('is-open');
	// 	  jsBtn.classList.toggle('is-buttonClose');
	// 	});
	// })
	// }
	//ページ内リンクがクリックされた時にスマホメニューを閉じる(version1.1)
	subMenu.forEach(function (subMenus) {
		subMenus.addEventListener('click', function () {
			jsBox.classList.remove('is-open');
			jsBtn.classList.toggle('is-buttonClose');
		});
	})

}
